import React from "react";
import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { Button } from "react-bootstrap";
import { useAuth } from "hooks/auth";
import { cilUser } from "@coreui/icons";
import { useHistory } from "react-router-dom";

const AppHeaderDropdown = (props: any) => {
  const auth = useAuth();
  const history = useHistory();

  return (
    <CDropdown className="c-header-nav-items mx-2">
      <CDropdownToggle
        color="light"
        className="c-header-nav-link"
        caret={false}
      >
        <CIcon icon={cilUser} className="cil-user"></CIcon>
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
        <CDropdownItem color="light" className="text-center">
          <strong>Account</strong>
        </CDropdownItem>
        <CDropdownItem onClick={() => history.push("/profile")} style={{ cursor: "pointer" }}>
          <CIcon icon={cilUser} className="me-2" />
          {auth.getEmail()}
        </CDropdownItem>
        <CDropdownItem>
          <Button className="w-100" onClick={() => auth.signOut()}>
            Sign Out
          </Button>
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  );
};

export default AppHeaderDropdown;
